import { Routes } from "@angular/router";
import { WorkflowEndcustomerOneCancelPhonenumberComponent } from "./workflow-endcustomer-one-cancel-phonenumber.component";

export const workflowEndcustomerOneCancelPhonenumberRouting: Routes = [
    { path: 'cancel-phonenumber/:aid/:bid', component: WorkflowEndcustomerOneCancelPhonenumberComponent, children: [
        { path: 'confirm', component: WorkflowEndcustomerOneCancelPhonenumberComponent, data: { step: 'confirm' } },
        { path: 'address', component: WorkflowEndcustomerOneCancelPhonenumberComponent, data: { step: 'address' } },
        { path: 'payment', component: WorkflowEndcustomerOneCancelPhonenumberComponent, data: { step: 'payment' } },
        { path: 'checkout-summary', component: WorkflowEndcustomerOneCancelPhonenumberComponent, data: { step: 'checkout-summary' } },
        { path: 'complete', component: WorkflowEndcustomerOneCancelPhonenumberComponent, data: { step: 'complete' } },
        { path: '', redirectTo: 'confirm', pathMatch: 'full' },
    ]},
]